export const PageSkeleton = ({ rows = 4 }) => (
  <div className="p-8 space-y-4 animate-pulse max-w-6xl mx-auto" data-testid="page-skeleton">
    <div className="h-8 w-48 rounded-lg bg-white/5" />
    <div className="h-4 w-72 rounded bg-white/5" />
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 pt-4">
      {[...Array(4)].map((_, i) => <div key={i} className="h-28 rounded-xl bg-white/5" />)}
    </div>
    <div className="space-y-3 pt-2">
      {[...Array(rows)].map((_, i) => <div key={i} className="h-14 rounded-xl bg-white/5" />)}
    </div>
  </div>
);
